import VT from '@/store/types';

export default {
  [VT.NOTIFICATIONS]: (state, { data, status }) => {
    state.notifications = { data, status };
  },
  [VT.NOTIFICATIONS_NEW]: (state, { data, status }) => {
    state.notificationsNew = { data, status };
  },
  [VT.NOTIFICATION_READ_UPDATE]: (state, { data, status }) => {
    state.notificationsReadUpdate = { data, status };
  },
};
